import { Strg } from "@/Configs";
import { Decrypt, Encrypt } from "./ENCS";
import { responseTypes } from "@/modules";


export const getAuthToken = async (): Promise<responseTypes> => {
    let ss = await localStorage.getItem(Strg.tkes);
    if (!ss) {
        return { success: false, message: "No token Found!", data: "" };
    }
    let dec = await Decrypt(ss);
    if (!dec.success) {
        return { success: false, message: dec.message, data: dec.data }
    }
    return { success: true, message: 'Error!, please try again', data: dec.data };
}

export const getAuthTokenCk = async (): Promise<responseTypes> => {
    let ss = await localStorage.getItem(Strg.tkes);
    if (!ss) {
        return { success: false, message: "No token Found!", data: "" };
    }
    let dec = await Decrypt(ss);
    if (!dec.success) {
        return { success: false, message: dec.message, data: dec.data }
    }
    return { success: true, message: 'Error!, please try again', data: dec.data };
}


export const setAuthToken = async ({ token }: { token: string }): Promise<responseTypes> => {
    try {
        const enc = await Encrypt(token);
        if (!enc.success) {
            return { success: false, message: enc.message, data: {} }
        }
        await localStorage.setItem(Strg.tkes, enc.data);
        return { success: true, message: '', data: {} };
    } catch (error) {
        console.log(error);
        return { success: false, message: 'Error!, please try again', data: {} };
    }
}
